import SharedNavbar from "@/components/SharedNavbar";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-background">
      <SharedNavbar />

      <div className="mx-auto max-w-4xl px-5 py-16 lg:px-8">
        {/* Impressum */}
        <section className="mb-16">
          <h1 className="text-3xl font-bold text-foreground">Impressum</h1>
          <div className="mt-8 space-y-6 text-sm leading-7 text-muted-foreground">
            <div>
              <h2 className="text-base font-bold text-foreground">Unternehmensangaben</h2>
              <p className="mt-2">
                DS Logistik GmbH<br/>
                Bielstrasse 20<br/>
                4500 Solothurn<br/>
                Schweiz
              </p>
            </div>
            <div>
              <h2 className="text-base font-bold text-foreground">Kontakt</h2>
              <p className="mt-2">
                Telefon: <a href="tel:+41326712010" className="text-primary hover:underline">032 671 20 10</a><br/>
                WhatsApp: <a href="https://wa.me/41798883262" className="text-primary hover:underline">079 888 32 62</a><br/>
                E-Mail: <a href="mailto:andre.stalder@ds-logistik.ch" className="text-primary hover:underline">andre.stalder@ds-logistik.ch</a>
              </p>
            </div>
            <div>
              <h2 className="text-base font-bold text-foreground">Geschäftsführung</h2>
              <p className="mt-2">
                CEO: Driton Selmani, Almedina Selmani<br/>
                COO: Sadik Alihajdaraj<br/>
                Geschäftsführer: André Stalder
              </p>
            </div>
            <div>
              <h2 className="text-base font-bold text-foreground">Handelsregister</h2>
              <p className="mt-2">Eingetragen im Handelsregister des Kantons Solothurn</p>
            </div>
            <div>
              <h2 className="text-base font-bold text-foreground">MWST</h2>
              <p className="mt-2">Mehrwertsteuerpflichtig gemäss schweizerischem Mehrwertsteuergesetz (MWSTG)</p>
            </div>
            <div>
              <h2 className="text-base font-bold text-foreground">Haftungsausschluss</h2>
              <p className="mt-2">Die Inhalte dieser Website wurden mit grösster Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr. Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.</p>
            </div>
          </div>
        </section>

        <hr className="border-border/60 my-12" />

        {/* Datenschutz */}
        <section>
          <h1 className="text-3xl font-bold text-foreground">Datenschutzerklärung</h1>
          <p className="mt-2 text-sm text-muted-foreground">Gemäss Bundesgesetz über den Datenschutz (DSG) und der DSGVO</p>
          <div className="mt-8 space-y-6 text-sm leading-7 text-muted-foreground">
            <div>
              <h2 className="text-base font-bold text-foreground">1. Verantwortliche Stelle</h2>
              <p className="mt-2">DS Logistik GmbH, Bielstrasse 20, 4500 Solothurn. E-Mail: andre.stalder@ds-logistik.ch</p>
            </div>
            <div>
              <h2 className="text-base font-bold text-foreground">2. Erhebung und Verarbeitung personenbezogener Daten</h2>
              <p className="mt-2">Wir erheben personenbezogene Daten nur, soweit dies für die Bereitstellung unserer Dienstleistungen erforderlich ist. Dies umfasst: Name, E-Mail-Adresse, Telefonnummer und Adresse bei Kontaktanfragen sowie Auftragsabwicklung.</p>
            </div>
            <div>
              <h2 className="text-base font-bold text-foreground">3. Zweck der Datenverarbeitung</h2>
              <p className="mt-2">Ihre Daten werden ausschliesslich zur Bearbeitung von Anfragen, zur Auftragsabwicklung (Lieferung, Montage, Entsorgung) und zur Kommunikation mit Ihnen verwendet. Eine Weitergabe an Dritte erfolgt nicht.</p>
            </div>
            <div>
              <h2 className="text-base font-bold text-foreground">4. Cookies</h2>
              <p className="mt-2">Diese Website verwendet keine Tracking-Cookies. Technisch notwendige Session-Daten werden lokal im Browser gespeichert und nicht an externe Server übertragen.</p>
            </div>
            <div>
              <h2 className="text-base font-bold text-foreground">5. Ihre Rechte</h2>
              <p className="mt-2">Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Anfragen richten Sie bitte an: andre.stalder@ds-logistik.ch</p>
            </div>
            <div>
              <h2 className="text-base font-bold text-foreground">6. Datensicherheit</h2>
              <p className="mt-2">Wir treffen angemessene technische und organisatorische Massnahmen zum Schutz Ihrer Daten gegen unbefugten Zugriff, Verlust oder Missbrauch.</p>
            </div>
            <div>
              <h2 className="text-base font-bold text-foreground">7. Kontakt Datenschutz</h2>
              <p className="mt-2">Bei Fragen zum Datenschutz wenden Sie sich an: <a href="mailto:andre.stalder@ds-logistik.ch" className="text-primary hover:underline">andre.stalder@ds-logistik.ch</a></p>
            </div>
          </div>
        </section>
      </div>

      <footer className="border-t border-border/40 bg-background py-6 text-center">
        <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} DS Logistik · Bielstrasse 20, 4500 Solothurn</p>
      </footer>
    </div>
  );
}
